import { render, staticRenderFns } from "./webcam-easy.vue?vue&type=template&id=3821605f&scoped=true&"
import script from "./webcam-easy.vue?vue&type=script&lang=js&"
export * from "./webcam-easy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821605f",
  null
  
)

export default component.exports